import React, { useState, useEffect, useRef, useContext } from 'react';
import PropTypes from 'prop-types';

import i18n from "i18next";

import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import InputGroup from 'react-bootstrap/InputGroup';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faPalette } from '@fortawesome/free-solid-svg-icons';

import t from '../Translation/Translation';
import TranslationSelector from '../Translation/TranslationSelector2';
import {ThemeSwitcher} from 'citric_components';

import conf from '../../config.json';
import ErrorBoundary from '../Error/ErrorBoundary';
import packageJson from '../../../package.json';

//import { SQLiteDBConnection } from "@capacitor-community/sqlite";
import { platform } from '../../App';
//import { SqliteServiceContext, StorageServiceContext } from '../../App';
import User from '../../models/User';
import { goToWebCitric, logD } from '../Util/Util';
import Header from '../Dashboard/Header';

import { IonPage, IonHeader, IonContent, useIonViewDidEnter,
    useIonViewDidLeave,
    useIonViewWillEnter,
    useIonViewWillLeave, } from '@ionic/react';

import './Login.css';
import i18next from 'i18next';

async function loginUser(credentials) {
    logD("loginUser", credentials);
    logD("loginUser", JSON.stringify(credentials));
    //const urlLogin = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/login/designer';
    const urlLogin = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/action/loginDash';
 return fetch(urlLogin, {
   method: 'POST',
   mode: 'cors',
   headers: {
     'Content-Type': 'application/json'
   },
   body: JSON.stringify(credentials),
 })
   .then(data => data.json())
}

export default function Login({ setToken, setModalOpen }) {
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();
  //const [remember, setRemember] = useState();
  const [showAlert, setShowAlert] = useState(false);
  const [alertCode, setAlertCode] = useState(1);
  const [alertMsg, setAlertMsg] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);
  const [lang, setLang] = useState(i18n.resolvedLanguage);
  const [serverV, setServerV] = useState('');

  console.log(lang);

  /*const ref = useRef(false);
  const dbNameRef = useRef('');
  const isInitComplete = useRef(false);
  const [db, setDb] = useState(null);
  const sqliteServ = useContext(SqliteServiceContext);
  const storageServ = useContext(StorageServiceContext);*/

  // Password toggle handler
  const togglePassword = () => {
    // When the handler is invoked
    // inverse the boolean state of passwordShown
    setPasswordShown(!passwordShown);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setShowAlert(false);
    const data = await loginUser({
        'username': username,
        'password': password,
    });
    logD("Login", data);
    setAlertCode(data.code);
    if(data.code === 1) {
        setModalOpen(false);
        const user = Object.assign(new User(), data);
        //handleAddUser(user);
        const usr = {
            'u': user.id_user,
            'r': user.role,
            'c': user.idc,
            'token': user.token,
            'name': user.name,
        }
        setToken(usr);
    } else {
        if(data.code === 500) {
            setAlertMsg(data.message);
        }
        setShowAlert(true);
    }
  }

  function serverVersion() {
    fetch(conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/util/version')
    .then(response => response.text())
    .then(data => setServerV(data));
  }

  /*const handleAddUser = async (newUser) => {
    if (db) {
      // Send the newUser to the addUser storage service method
      const isConn = await sqliteServ.isConnection(dbNameRef.current,false);
      const lastId = await storageServ.addUser(newUser);
        console.log("Insert User " + lastId);

    }
    sqliteServ.closeDatabase(dbNameRef.current,false).then(() => {
        ref.current = false;  
      })
      .catch((error) => {
        const msg = `Error close database:: ${error}`;
        console.error(msg);     
      });
  };*/

  useEffect(() => {
    //serverVersion();
  }, []);

  /*const openDatabase = () => {
    try {
        console.log('openDatabase');
      const dbUsersName = storageServ.getDatabaseName();
      dbNameRef.current = dbUsersName;
      const version = storageServ.getDatabaseVersion();

      sqliteServ.openDatabase(dbUsersName, version, false).then((database) => {
        setDb(database);
        ref.current = true;
      });
    } catch (error) {
      const msg = `Error open database:: ${error}`;
      console.error(msg);        
    }
  }

  useIonViewWillEnter(async () => {
    console.log('useIonViewWillEnter');
    const initSubscription = storageServ.isInitCompleted;
    //.subscribe((value) => {
      //isInitComplete.current = value;
      if(initSubscription === true) {
        console.log('isInitComplete');
        const dbUsersName = storageServ.getDatabaseName();
        if(ref.current === false) {
          if(platform === "web") {
            customElements.whenDefined('jeep-sqlite').then(() => {
              openDatabase();
            })
            .catch ((error) => {
              const msg = `Error open database:: ${error}`;
              console.log(`msg`);       
            });

          } else {
            openDatabase();
          }
        }
      }
    //});

    return () => {
      initSubscription.unsubscribe();
    };
  }, []);*/

  return(
    <IonPage>
        <IonHeader>
            <Header lang={lang} setToken={setToken} token={null}/>
        </IonHeader>
        <Container className="mb-3 h-100 align-content-center">
            <ErrorBoundary>
            <Row className="justify-content-md-center">
                <Col md="6">
                    <Card>
                        <Card.Body>
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>{t('user')}</Form.Label>
                                    <Form.Control required type="text" placeholder={t('user')} onChange={e => setUserName(e.target.value)} />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                    <Form.Label>{t('password')}</Form.Label>
                                    <InputGroup>
                                        <Form.Control required type={passwordShown ? "text" : "password"} placeholder={t('password')} onChange={e => setPassword(e.target.value)} />
                                        <Button variant="outline-secondary" id="button-addon1" onClick={togglePassword}>
                                            {passwordShown ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                        </Button>
                                    </InputGroup>
                                </Form.Group>
                                {/*<Form.Group className="mb-3" controlId="formBasicCheckbox">
                                    <Row>
                                        <Col md="6">
                                            <TranslationSelector current={lang} func={setLang}/>
                                        </Col>
                                        <Col md="6" className='align-content-center'>
                                            <ThemeSwitcher classes="d-flex align-items-center pointer" text={<span>{t('toogle_theme')}</span>} icon={<div className="d-inline-flex me-3"><FontAwesomeIcon className='theme_btn' icon={faPalette} /></div>}/>
                                        </Col>
                                    </Row>
                                </Form.Group>*/}
                                <Button variant="primary" type="submit">
                                {t('login')}
                                </Button>
                                {showAlert && <Alert className="mt-3" variant="danger" onClose={() => setShowAlert(false)} dismissible>
                                    <span className="login_message">
                                    { alertCode === 2 && t('login_changepass') }
                                    { alertCode === 3 && t('login_timedout') }
                                    { alertCode === 4 && t('login_exceeded') }
                                    { alertCode === 5 && t('login_no') }
                                    { alertCode === 500 && t(alertMsg) }
                                    </span>
                                </Alert>}
                                {/*<Row>
                                    <Col>
                                        {'Designer ' + packageJson.version + ' SV ' + serverV}
                                    </Col>
                                </Row>*/}
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            </ErrorBoundary>
        </Container>
        {/*<footer className="justify-content-between align-items-center mb-4">
            <Row className="d-flex align-items-end h-100">
                <Col md="11" className=''>
                    <div className="brandLogo cd-end pointer" onClick={() => goToWebCitric(i18n.resolvedLanguage)}></div>
                </Col>
                <Col md="1" className="d-flex align-items-center">
                    <div className="ion-text-end">
                        <span>{"v" + conf.version}</span>
                    </div>
                </Col>
            </Row>
        </footer>*/}
    </IonPage>
  )
}

Login.propTypes = {
  setToken: PropTypes.func.isRequired
};